import { EditorState, SelectionState } from 'draft-js'
import { EditorStateOps, TaskState } from '@src/editor-helpers'

export default (editorState: EditorState) => {
  const focusBlock = EditorStateOps.getFocusBlock(editorState)
  const taskState = TaskState.fromEditorState(editorState)
  const currentTask = TaskState.getTaskByKey(taskState, focusBlock.get('key'))
  const decisionKey = TaskState.getDecisionBlockKey(currentTask)
  const contentState = editorState.getCurrentContent()
  const focusDecisionBlock = contentState.getBlockForKey(decisionKey)

  editorState = EditorState.undo(editorState)
  editorState = EditorState.undo(editorState)

  const conspectBlock = EditorStateOps.createContentBlock()
  const solutionBlock = EditorStateOps.createContentBlock('', 'solution')
  const decisionBlock = EditorStateOps.createContentBlock('', 'decision')

  editorState = EditorState.set(editorState, { allowUndo: false })
  editorState = EditorStateOps.insertBlock(editorState, conspectBlock, focusDecisionBlock)
  editorState = EditorStateOps.insertBlock(editorState, solutionBlock, conspectBlock)
  editorState = EditorStateOps.insertBlock(editorState, decisionBlock, solutionBlock)

  const key = conspectBlock.getKey()
  const newSelection = SelectionState.createEmpty(key)

  editorState = EditorState.forceSelection(editorState, newSelection)
  editorState = EditorState.set(editorState, { allowUndo: true })

  return editorState
}



// WEBPACK FOOTER //
// ./src/editor-helpers/EditorStateOps/addTask.ts